"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const { getAxiosInstance } = require("../../utils/tools");
class NowNodes {
    constructor({ token, timeout = 30000 }, testnet = false) {
        const mainnetUrl = "https://btcbook.nownodes.io/";
        const testnetUrl = "https://btcbook-testnet.nownodes.io/";
        this.baseURL = testnet ? testnetUrl : mainnetUrl;
        this.axios = getAxiosInstance({
            baseUrl: this.baseURL,
            timeout,
            headers: {
                "api-key": token,
            },
        });
    }
    getUtxos(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.axios.get(`/api/v2/utxo/${address}`);
            const utxos = result.data.map((tx) => ({
                address,
                txId: tx.txid,
                index: tx.vout,
                value: Number(tx.value),
                blockNumber: +tx.height,
            }));
            return utxos;
        });
    }
}
module.exports = NowNodes;
//# sourceMappingURL=nownodes.js.map